import List from './list/ReferralCategoryListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})